import { initFlashControl } from '../ui/flash_control';

document.addEventListener("DOMContentLoaded", () => {
    initFlashControl();
});